import axios from "axios"
export default {
  computed: {
    $_requiredValidation() {
      return [(val) => !!val || this.$t("checklistapi.common.required")]
    },
    $_multiSelectValidation() {
      return [
        (val) => !!val || this.$t("checklistapi.common.required"),
        (val) => (val && val.length > 0) || this.$t("checklistapi.common.required")
      ]
    },
    $_numberValidation() {
      return [
        (val) => (val ? /^[0-9]+$/.test(val) || this.$t("checklistapi.common.invalidNumber") : true),
        (val) => (val ? !isNaN(this.$format.replaceCommaWithDot(val)) || this.$t("checklistapi.common.invalidNumber") : true)
      ]
    },
    $_norwegianNumberValidation() {
      return [
        (val) => (val ? /^[0-9.,]+$/.test(val) || this.$t("checklistapi.common.invalidNumber") : true),
        (val) => (val ? !isNaN(this.$format.replaceCommaWithDot(val)) || this.$t("checklistapi.common.invalidNumber") : true)
      ]
    },
    $_norwegianNumberMinusValidation() {
      return [
        (val) => (val ? /^-?[0-9.,]+$/.test(val) || this.$t("checklistapi.common.invalidNumber") : true),
        (val) => (val ? !isNaN(this.$format.replaceCommaWithDot(val)) || this.$t("checklistapi.common.invalidNumber") : true)
      ]
    },
    $_emailValidation() {
      return [
        (v) =>
          v ? /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) || this.$t("checklistapi.common.invalidEmail") : true
      ]
    },
    $_discountValidation() {
      return [
        (val) =>
          val
            ? (this.$format.replaceCommaWithDot(val) <= 100 && this.$format.replaceCommaWithDot(val) >= 0) ||
              this.$t("checklistapi.common.invalidNumber")
            : true
      ]
    },
    $_numberLength() {
      return [(val) => (val ? (val && val.length <= 4) || this.$t("checklistapi.common.maxCharacters", { charCount: 4 }) : true)]
    },
    $_passwordConfirmationRules() {
      return [
        (v) => !!v || this.$t("checklistapi.common.required"),
        (v) => v === this.resetObj.password || this.$t("checklistapi.login.passwordMatch")
      ]
    },
    $_fieldNameValidation() {
      return [(v) => (v ? /^[a-zA-Z0-9_]*$/.test(v) || "Invalid name" : true)]
    }
  },
  methods: {
    /* checkPermissions (permission) {
      let checkPermissions = this.$store.state.rolePermissions
      let isAdmin = this.$store.state.userDetails.id
      if (isAdmin === 1) {
        return true
      } else if (checkPermissions.includes(permission)) {
        return true
      } else {
        return false
      }
    }, */

    /* Handle Alert Messages for the response success and fail */
    handleAlert(color, message) {
      this.$store.commit("hideLoader")
      this.$root.$emit("snackbar", {
        snackbar: true,
        color: color,
        message: message
      })
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split("-")
      return `${day}.${month}.${year}`
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split(".")
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
    },

    loadCompanyData() {
      axios
        .get("https://data.brreg.no/enhetsregisteret/api/enheter?navn=" + encodeURIComponent(this.search), { headers: "" })
        .then((response) => {
          this.items = response.data._embedded.enheter
          this.companyNames = []
          if (this.items !== undefined) {
            for (let i = 0; i < this.items.length; i++) {
              this.companyNames.push(this.items[i].navn)
            }
          }
        })
    },
    loadCompanyDataByNr() {
      axios
        .get("https://data.brreg.no/enhetsregisteret/api/enheter?organisasjonsnummer=" + encodeURIComponent(this.customer_search), {
          headers: ""
        })
        .then((response) => {
          this.items = response.data._embedded.enheter
          this.customerNumbers = []
          if (this.items !== undefined) {
            for (let i = 0; i < this.items.length; i++) {
              this.customerNumbers.push(this.items[i].organisasjonsnummer)
            }
          }
        })
    },

    fillAddress(name) {
      if (this.companyNames.length !== 0) {
        if (this.items !== undefined) {
          for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].navn === name) {
              this.customer.VAT = this.items[i].organisasjonsnummer
              this.customer.address = Array.isArray(this.items[i].forretningsadresse.adresse)
                ? this.items[i].forretningsadresse.adresse.join(", ")
                : this.items[i].forretningsadresse.adresse
              this.customer.visiting_street = Array.isArray(this.items[i].forretningsadresse.adresse)
                ? this.items[i].forretningsadresse.adresse.join(", ")
                : this.items[i].forretningsadresse.adresse
              this.customer.visiting_postal = this.items[i].forretningsadresse.postnummer
              this.customer.visiting_city = this.items[i].forretningsadresse.poststed
              this.customer.visiting_state = this.items[i].forretningsadresse.kommune
              break
            } else {
              this.customer.customer_number = ""
              this.customer.address = ""
              this.customer.visiting_street = ""
              this.customer.visiting_postal = ""
              this.customer.visiting_city = ""
              this.customer.visiting_state = ""
            }
          }
        }
      }
    },
    fillAddressByNr(organisasjonsnummer) {
      if (this.customerNumbers.length !== 0) {
        if (this.items !== undefined) {
          for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].organisasjonsnummer === organisasjonsnummer) {
              this.customer.customer_number = this.items[i].organisasjonsnummer
              this.customer.VAT = this.items[i].organisasjonsnummer
              this.customer.name = this.items[i].navn
              this.customer.address = Array.isArray(this.items[i].forretningsadresse.adresse)
                ? this.items[i].forretningsadresse.adresse.join(", ")
                : this.items[i].forretningsadresse.adresse
              this.customer.visiting_street = Array.isArray(this.items[i].forretningsadresse.adresse)
                ? this.items[i].forretningsadresse.adresse.join(", ")
                : this.items[i].forretningsadresse.adresse
              this.customer.visiting_postal = this.items[i].forretningsadresse.postnummer
              this.customer.visiting_city = this.items[i].forretningsadresse.poststed
              this.customer.visiting_state = this.items[i].forretningsadresse.kommune

              break
            } else {
              this.customer.customer_number = ""
              this.customer.address = ""
              this.customer.navn = ""
              this.customer.visiting_street = ""
              this.customer.visiting_postal = ""
              this.customer.visiting_state = ""
            }
          }
        }
      }
    },

    handleServerSideError(error) {
      this.$store.commit("hideLoader")
      switch (error.response && error.response.status) {
        case 404:
          if (this.$store.state.isLoggedIn === true) this.$router.push("dashboard")
          else this.$router.push("/login")
          break
        case 422:
          this.handleAlert("error", Object.values(error.response.data.errors)[0][0])
          break
        case 401:
          this.$router.push("/login")
          break
        default:
          this.handleAlert("error", this.$t("message.common.wentWrongMsg"))
          break
      }
    },

    handleReportDownload(type, ids) {
      let data = {
        type: type,
        ids: [ids]
      }
      axios.post("/completereport", data).then(({ data }) => {
        if (data.file) window.open(data.file, "_self")
        this.handleAlert("success", this.$t("message.common.downloaded_success"))
        this.$store.commit("hideLoader", false)
      })
    },

    /* Handle Bulk Report */
    handleBulkReportDownload(type, ids, lang) {
      if (ids.length !== 0) {
        let data = {
          type: type,
          ids: ids,
          lang: lang
        }
        this.$store.commit("showLoader", false)
        axios
          .post("/completereport", data)
          .then(({ data }) => {
            if (data.file) window.open(data.file, "_self")
            this.handleAlert("success", this.$t("message.common.downloaded_success"))
            this.$store.commit("hideLoader", false)
          })
          .catch(({ response }) => {
            this.handleAlert("error", response)
            this.$store.commit("hideLoader", false)
          })
      } else {
        this.$store.commit("hideLoader", false)
        this.handleAlert("error", this.$t("message.reports.select_report"))
      }
    },

    /* Formate date */
    formatToPickerDateFormat(date) {
      return moment(date, "DD.MM.YYYY").format("YYYY-MM-DD")
    },

    /* Handle Bulk Report Attachment */
    handleBulkReportSendAttachment(type, ids) {
      if (ids.length !== 0) {
        this.reportDialog = true
        this.reportType = type
        this.reportIds = ids
      } else {
        this.$store.commit("hideLoader", false)
        this.handleAlert("error", this.$t("message.reports.select_report"))
      }
    },

    getEmployeesDropdowns() {
      this.$store.commit("showLoader")
      axios
        .get(`employee?only_items=true`)
        .then(({ data }) => {
          this.listOfEmployees = data
          this.$store.commit("hideLoader")
        })
        .catch(({ response }) => {
          this.$store.commit("hideLoader")
          this.handleAlert("error", response)
          this.$store.commit("hideLoader", false)
        })
    },

    getCustomerContacts() {
      this.$store.commit("showLoader")
      axios
        .get(`contact?only_items=true&only_email=true`)
        .then(({ data }) => {
          this.listOfContacts = data
          this.$store.commit("hideLoader")
        })
        .catch((error) => {
          this.$store.commit("hideLoader")
          if (error.response) {
            this.$root.$emit("snackbar", {
              snackbar: true,
              color: "error",
              message: this.wentWrongMsg
            })
          }
        })
    },

    /* Send Report Mail */
    handleFormReportByModule(type, ids, lang) {
      if (this.reportEmails.length || this.externalEmails.length) {
        let data = {
          type: type,
          ids: ids,
          report_type: "email",
          emails: this.reportEmails,
          external_emails: this.externalEmails,
          lang: lang
        }
        this.$store.commit("showLoader", false)
        axios
          .post("/completereport", data)
          .then(({ data }) => {
            this.reportEmails = []
            this.externalEmails = ""
            this.handleAlert("success", this.$t("message.reports.sentSuccessfully"))
            this.$store.commit("hideLoader", false)
          })
          .catch(({ response }) => {
            this.handleAlert("error", response)
            this.$store.commit("hideLoader", false)
          })
        this.reportDialog = false
      } else {
        this.$store.commit("hideLoader", false)
        this.handleAlert("error", this.$t("message.reports.select_email"))
      }
    }
  }
}
